import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";

import { AlternatesModule } from "@hermes/fragments/alternates";
import { UserStateModule } from "@hermes/states/user";
import { OriginCheckerService } from "@hermes/utils-generic/services/origin-checker";

import { StoryEffects } from "./effects/story.effects";
import { StoryFacade } from "./facades/story.facade";
import * as fromStory from "./reducers/story.reducer";
import { PageAnalyticsService } from "./service/analytics/page-analytics.service";
import { StoryHeadService } from "./service/head/story-head.service";
import { StoryService } from "./service/story.service";

@NgModule({
    providers: [
        OriginCheckerService,
        StoryService,
        StoryHeadService,
        StoryFacade,
        PageAnalyticsService,
    ],
    imports: [
        CommonModule,
        StoreModule.forFeature(fromStory.storyFeatureKey, fromStory.reducer),
        EffectsModule.forFeature([StoryEffects]),
        UserStateModule,
        AlternatesModule,
    ],
})
export class StoryStateModule {}
